/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Androidbeta_Alreadyregistereddesc23Inputs */

const id_forms_androidbeta_alreadyregistereddesc23 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistereddesc23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jika Anda sudah ditambahkan ke daftar penguji, Anda dapat bergabung dengan beta di sini:`)
};

const ms_forms_androidbeta_alreadyregistereddesc23 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistereddesc23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jika anda telah ditambah ke senarai penguji, anda boleh menyertai beta di sini:`)
};

const da_forms_androidbeta_alreadyregistereddesc23 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistereddesc23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvis du allerede er blevet tilføjet til testerlisten, kan du deltage i betaen her:`)
};

const de_forms_androidbeta_alreadyregistereddesc23 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistereddesc23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn Sie bereits zur Testerliste hinzugefügt wurden, können Sie hier an der Beta teilnehmen:`)
};

const en_us2_forms_androidbeta_alreadyregistereddesc23 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistereddesc23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you have already been added to the testers list, you can join the beta here:`)
};

const es_es2_forms_androidbeta_alreadyregistereddesc23 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistereddesc23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si ya se te ha añadido a la lista de testers, puedes unirte a la beta aquí:`)
};

const es_mx2_forms_androidbeta_alreadyregistereddesc23 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistereddesc23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si ya has sido agregado a la lista de testers, puedes unirte a la beta aquí:`)
};

const fil_forms_androidbeta_alreadyregistereddesc23 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistereddesc23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kung naidagdag ka na sa listahan ng mga tester, maaari kang sumali sa beta dito:`)
};

const fr_forms_androidbeta_alreadyregistereddesc23 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistereddesc23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si vous avez déjà été ajouté à la liste des testeurs, vous pouvez rejoindre la bêta ici :`)
};

const it_forms_androidbeta_alreadyregistereddesc23 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistereddesc23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se sei già stato aggiunto all'elenco dei tester, puoi partecipare alla beta qui:`)
};

const hu_forms_androidbeta_alreadyregistereddesc23 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistereddesc23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ha már hozzáadtak a tesztelők listájához, itt csatlakozhatsz a bétához:`)
};

const nl_forms_androidbeta_alreadyregistereddesc23 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistereddesc23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als je al bent toegevoegd aan de testerlijst, kun je hier deelnemen aan de bèta:`)
};

const no_forms_androidbeta_alreadyregistereddesc23 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistereddesc23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvis du allerede er lagt til i testerlisten, kan du bli med i betaen her:`)
};

const pl_forms_androidbeta_alreadyregistereddesc23 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistereddesc23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeśli zostałeś już dodany do listy testerów, możesz dołączyć do bety tutaj:`)
};

const pt_br2_forms_androidbeta_alreadyregistereddesc23 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistereddesc23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you have already been added to the testers list, you can join the beta here:`)
};

const pt_forms_androidbeta_alreadyregistereddesc23 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistereddesc23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se já foi adicionado à lista de testers, pode juntar-se à beta aqui:`)
};

const ro_forms_androidbeta_alreadyregistereddesc23 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistereddesc23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dacă ai fost deja adăugat pe lista de testeri, te poți alătura betai aici:`)
};

const fi_forms_androidbeta_alreadyregistereddesc23 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistereddesc23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jos sinut on jo lisätty testaajien listalle, voit liittyä betaan täällä:`)
};

const sv_forms_androidbeta_alreadyregistereddesc23 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistereddesc23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om du redan har lagts till i testlistan kan du gå med i betan här:`)
};

const vi_forms_androidbeta_alreadyregistereddesc23 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistereddesc23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nếu bạn đã được thêm vào danh sách người thử nghiệm, bạn có thể tham gia beta tại đây:`)
};

const tr_forms_androidbeta_alreadyregistereddesc23 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistereddesc23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test uzmanları listesine zaten eklendiyseniz, beta'ya buradan katılabilirsiniz:`)
};

const cs_forms_androidbeta_alreadyregistereddesc23 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistereddesc23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokud jste již byli přidáni do seznamu testerů, můžete se připojit k beta verzi zde:`)
};

const bg_forms_androidbeta_alreadyregistereddesc23 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistereddesc23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ако вече сте добавени към списъка на тестерите, можете да се присъедините към бета версията тук:`)
};

const ru_forms_androidbeta_alreadyregistereddesc23 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistereddesc23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Если вы уже добавлены в список тестировщиков, вы можете присоединиться к бета-тесту здесь:`)
};

const uk_forms_androidbeta_alreadyregistereddesc23 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistereddesc23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Якщо вас уже додали до списку тестувальників, ви можете приєднатися до бета-версії тут:`)
};

const ar_forms_androidbeta_alreadyregistereddesc23 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistereddesc23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إذا تمت إضافتك بالفعل إلى قائمة المختبرين، يمكنك الانضمام إلى الإصدار التجريبي هنا:`)
};

const hi_forms_androidbeta_alreadyregistereddesc23 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistereddesc23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यदि जोड़ा गया है, तो यहाँ शामिल हों:`)
};

const th_forms_androidbeta_alreadyregistereddesc23 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistereddesc23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หากคุณถูกเพิ่มในรายชื่อผู้ทดสอบแล้ว คุณสามารถเข้าร่วมเบต้าได้ที่นี่:`)
};

const ja_forms_androidbeta_alreadyregistereddesc23 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistereddesc23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すでにテスターリストに追加されている場合は、こちらからベータ版に参加できます：`)
};

const zh_cn2_forms_androidbeta_alreadyregistereddesc23 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistereddesc23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you have already been added to the testers list, you can join the beta here:`)
};

const zh_hant1_forms_androidbeta_alreadyregistereddesc23 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistereddesc23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you have already been added to the testers list, you can join the beta here:`)
};

const ko_forms_androidbeta_alreadyregistereddesc23 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistereddesc23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you have already been added to the testers list, you can join the beta here:`)
};

/**
* | output |
* | --- |
* | "If you have already been added to the testers list, you can join the beta here:" |
*
* @param {Forms_Androidbeta_Alreadyregistereddesc23Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_androidbeta_alreadyregistereddesc23 = /** @type {((inputs?: Forms_Androidbeta_Alreadyregistereddesc23Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Androidbeta_Alreadyregistereddesc23Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_androidbeta_alreadyregistereddesc23(inputs)
	if (locale === "ms") return ms_forms_androidbeta_alreadyregistereddesc23(inputs)
	if (locale === "da") return da_forms_androidbeta_alreadyregistereddesc23(inputs)
	if (locale === "de") return de_forms_androidbeta_alreadyregistereddesc23(inputs)
	if (locale === "en-US") return en_us2_forms_androidbeta_alreadyregistereddesc23(inputs)
	if (locale === "es-ES") return es_es2_forms_androidbeta_alreadyregistereddesc23(inputs)
	if (locale === "es-MX") return es_mx2_forms_androidbeta_alreadyregistereddesc23(inputs)
	if (locale === "fil") return fil_forms_androidbeta_alreadyregistereddesc23(inputs)
	if (locale === "fr") return fr_forms_androidbeta_alreadyregistereddesc23(inputs)
	if (locale === "it") return it_forms_androidbeta_alreadyregistereddesc23(inputs)
	if (locale === "hu") return hu_forms_androidbeta_alreadyregistereddesc23(inputs)
	if (locale === "nl") return nl_forms_androidbeta_alreadyregistereddesc23(inputs)
	if (locale === "no") return no_forms_androidbeta_alreadyregistereddesc23(inputs)
	if (locale === "pl") return pl_forms_androidbeta_alreadyregistereddesc23(inputs)
	if (locale === "pt-BR") return pt_br2_forms_androidbeta_alreadyregistereddesc23(inputs)
	if (locale === "pt") return pt_forms_androidbeta_alreadyregistereddesc23(inputs)
	if (locale === "ro") return ro_forms_androidbeta_alreadyregistereddesc23(inputs)
	if (locale === "fi") return fi_forms_androidbeta_alreadyregistereddesc23(inputs)
	if (locale === "sv") return sv_forms_androidbeta_alreadyregistereddesc23(inputs)
	if (locale === "vi") return vi_forms_androidbeta_alreadyregistereddesc23(inputs)
	if (locale === "tr") return tr_forms_androidbeta_alreadyregistereddesc23(inputs)
	if (locale === "cs") return cs_forms_androidbeta_alreadyregistereddesc23(inputs)
	if (locale === "bg") return bg_forms_androidbeta_alreadyregistereddesc23(inputs)
	if (locale === "ru") return ru_forms_androidbeta_alreadyregistereddesc23(inputs)
	if (locale === "uk") return uk_forms_androidbeta_alreadyregistereddesc23(inputs)
	if (locale === "ar") return ar_forms_androidbeta_alreadyregistereddesc23(inputs)
	if (locale === "hi") return hi_forms_androidbeta_alreadyregistereddesc23(inputs)
	if (locale === "th") return th_forms_androidbeta_alreadyregistereddesc23(inputs)
	if (locale === "ja") return ja_forms_androidbeta_alreadyregistereddesc23(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_androidbeta_alreadyregistereddesc23(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_androidbeta_alreadyregistereddesc23(inputs)
	return ko_forms_androidbeta_alreadyregistereddesc23(inputs)
});
export { forms_androidbeta_alreadyregistereddesc23 as "forms.androidBeta.alreadyRegisteredDesc2" }